import { UseDisclosureProps } from '@chakra-ui/react';
import { useUpdateTeamGoal } from '@frx/frx-react-context';
import { FC } from 'react';
import { Modal } from '../../../../components';
import { ChangeGoal } from '../../../../components/change-goal/ChangeGoal';
import { useEventId } from '../../../../hooks';

export interface TeamGoalProps
  extends Required<Pick<UseDisclosureProps, 'isOpen' | 'onClose'>> {
  teamGoal: number;
}

export const TeamGoal: FC<TeamGoalProps> = ({ isOpen, onClose, teamGoal }) => {
  const eventId = useEventId();
  const {
    mutate: updateTeamGoal,
    error,
    reset: resetQuery,
  } = useUpdateTeamGoal();

  const handleOnSave = (goalAmount: number) =>
    updateTeamGoal(
      { fr_id: eventId, team_goal: goalAmount },
      {
        onSuccess: () => {
          onClose();
        },
      }
    );

  const handleOnCancel = () => {
    resetQuery();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleOnCancel} modalTitle="Edit Team Goal">
      <ChangeGoal
        onSubmit={handleOnSave}
        onCancel={handleOnCancel}
        errorMessage={error?.message as string}
        goalAmount={teamGoal}
      />
    </Modal>
  );
};
